import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import AmazonForm from './amazonForm.vue';
import util from '@/utils/util';
var amazonFormCom = util.mountVueComponent(AmazonForm);

var FbaReturnAccountPage = function (_super) {
  __extends(FbaReturnAccountPage, _super);

  function FbaReturnAccountPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.fbaReturnAccountStatusEnum = [];
    _this.smazonSiteEnum = [];
    _this.searchData = _this.initSearchData();
    _this.loadingStatus = false;
    _this.columns = [];
    _this.dataList = [];
    _this.total = 0;
    return _this;
  }

  FbaReturnAccountPage.prototype.initSearchData = function () {
    return {
      site: undefined,
      status: undefined,
      account_name: '',
      page_index: 1,
      page_size: 20
    };
  };

  FbaReturnAccountPage.prototype.handleSearch = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.searchData.page_index = 1;
            return [4, this.queryList()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  FbaReturnAccountPage.prototype.handleClear = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _this = this;

      return __generator(this, function (_a) {
        this.searchData = this.initSearchData();
        this.$nextTick(function () {
          return _this.queryList();
        });
        return [2];
      });
    });
  };

  FbaReturnAccountPage.prototype.handlePageChange = function (page, pageSize) {
    this.searchData.page_index = page;
    this.searchData.page_size = pageSize;
    this.queryList();
  };

  FbaReturnAccountPage.prototype.handleAddPlatform = function () {
    var _this = this;

    amazonFormCom({
      parent: this,
      propsData: {
        data: {},
        onSuccess: function onSuccess() {
          _this.queryList();
        }
      }
    });
  };

  FbaReturnAccountPage.prototype.queryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _i, _a, key, _b, resData, _c, _d, list, _e, total;

      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            postData = {};

            for (_i = 0, _a = Object.keys(this.searchData); _i < _a.length; _i++) {
              key = _a[_i];
              postData[key] = this.searchData[key];
            }

            return [4, this.$api.fbaReturnAccount.queryList(postData)];

          case 1:
            _b = _f.sent().data, resData = _b === void 0 ? {} : _b;
            _c = resData, _d = _c.list, list = _d === void 0 ? [] : _d, _e = _c.total, total = _e === void 0 ? 0 : _e;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  FbaReturnAccountPage.prototype.handleAuth = function (data) {
    this.amazonAuth(data);
  };

  FbaReturnAccountPage.prototype.amazonAuth = function (data) {
    var _this = this;

    amazonFormCom({
      parent: this,
      propsData: {
        data: data,
        onSuccess: function onSuccess() {
          _this.queryList();
        }
      }
    });
  };

  FbaReturnAccountPage.prototype.handleDelete = function (record) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        this.confirmDeleteSingle(record.id);
        return [2];
      });
    });
  };

  FbaReturnAccountPage.prototype.confirmDeleteSingle = function (id) {
    var _this = this;

    var modal = this.$confirm({
      title: this.t('删除提示'),
      content: this.t('确认删除该平台账号吗？'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, Promise, function () {
          var code, error_1;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                _a.trys.push([0, 2,, 3]);

                return [4, this.$api.fbaReturnAccount.deleteAccount({
                  id: id
                })];

              case 1:
                code = _a.sent().code;

                if (code === 0) {
                  this.$message.success(this.t('删除成功'));
                  this.queryList();
                }

                return [3, 3];

              case 2:
                error_1 = _a.sent();
                modal.destroy();
                return [3, 3];

              case 3:
                return [2];
            }
          });
        });
      }
    });
  };

  FbaReturnAccountPage.prototype.created = function () {
    this.setColumns();
    this.queryList();
  };

  FbaReturnAccountPage.prototype.setColumns = function () {
    this.columns = [{
      title: this.t('店铺账号'),
      dataIndex: 'account_name',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('显示名称'),
      dataIndex: 'platform_user_name',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('站点'),
      dataIndex: 'site',
      filterEmpty: true
    }, {
      dataIndex: 'status_text',
      filterEmpty: true,
      scopedSlots: {
        title: 'status_text_title'
      }
    }, {
      title: this.t('新增时间'),
      dataIndex: 'created_at',
      filterEmpty: true
    }, {
      title: this.t('授权过期时间'),
      dataIndex: 'expired_time',
      filterEmpty: true,
      scopedSlots: {
        customRender: 'expired_time'
      }
    }, {
      width: 190,
      title: this.t('操作'),
      fixed: 'right',
      key: 'operation',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
  };

  FbaReturnAccountPage.prototype.showExpiredTime = function (record) {
    if (record.status === this.$enum.mine.FbaReturnAccountStatusEnum.ENABLED) {
      return this.t('永久');
    }

    return this.$util.filterEmpty('', true);
  };

  __decorate([enumData('Platform/FbaReturnAccountStatusEnum')], FbaReturnAccountPage.prototype, "fbaReturnAccountStatusEnum", void 0);

  __decorate([enumData('Platform/AmazonSiteEnum')], FbaReturnAccountPage.prototype, "smazonSiteEnum", void 0);

  __decorate([userPrefPageSize('fbaReturnAccountList')], FbaReturnAccountPage.prototype, "initSearchData", null);

  __decorate([loading('loadingStatus')], FbaReturnAccountPage.prototype, "queryList", null);

  FbaReturnAccountPage = __decorate([Component({
    components: {
      AmazonForm: AmazonForm
    }
  })], FbaReturnAccountPage);
  return FbaReturnAccountPage;
}(Vue);

export default FbaReturnAccountPage;